import { css } from 'styled-components';
// Note: this is a visual match to the spec due to differences on
// shadow handling and implementation between sketch and the code below
export const injectOverlayShadow = () => css `
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.15))
    drop-shadow(0 0 2px rgba(0, 0, 0, 0.2));
`;
//# sourceMappingURL=injectOverlayShadow.js.map